import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import dynamic from 'next/dynamic';
import styles from '@features/cms/components/categories/CategoryGalleryBlock/CategoryGalleryBlock.styles';
import { ICategoryGalleryBlock } from '@features/cms/typescript';
import CategoryGalleryStore from '@features/cms/components/categories/CategoryGalleryBlock/mobx/store/CategoryGalleryStore';
import { AsidePropsType } from '@components/Aside/Aside';
import CategoryAsideFilters from '@features/cms/components/categories/CategoryGalleryBlock/components/CategoryAsideFilters/CategoryAsideFilters';
import ActiveFiltersChips from '@features/cms/components/categories/CategoryGalleryBlock/components/ActiveFiltersChips/ActiveFiltersChips';
import Filters from '@features/cms/components/categories/CategoryGalleryBlock/components/Filters/Filters';
import ListingFooter from '@features/cms/components/categories/CategoryGalleryBlock/components/ListingFooter/ListingFooter';
import ListingHeader from '@features/cms/components/categories/CategoryGalleryBlock/components/ListingHeader/ListingHeader';
import Listing from '@features/cms/components/categories/CategoryGalleryBlock/components/Listing/Listing';
import theme from '@styles/theme';
import ListingMobile from '@features/cms/components/categories/CategoryGalleryBlock/components/Listing/ListingMobile';
import useResponsive from '@features/responsive/hooks/useResponsive';
const DynamicAside = dynamic<AsidePropsType>(() => import('@features/cms/components/categories/CategoryGalleryBlock/components/Aside/Aside') as Promise<never>);
type PropsType = {
  data: ICategoryGalleryBlock;
  defaultBackground?: string;
  isFirst?: boolean;
};
const CategoryGalleryBlock = ({
  data,
  defaultBackground = theme.rawColors.neutralWhite,
  isFirst = false
}: PropsType) => {
  const {
    isWiderThanTablet
  } = useResponsive();
  const {
    code,
    title,
    description,
    images: imagesArray,
    availableTags,
    background,
    marginTop,
    marginBottom
  } = data;
  const [categoryStore, setCategoryStore] = useState<CategoryGalleryStore>(new CategoryGalleryStore(imagesArray, availableTags));
  const {
    images,
    allImagesCount,
    isAsideOpen,
    closeAside,
    availableFiltersState
  } = categoryStore;
  const shouldRenderFilters = availableFiltersState ? !(availableFiltersState.attributes.length === 1 && availableFiltersState?.attributes[0].values.length === 1) : false;
  useEffect(() => {
    if (imagesArray) {
      const store = new CategoryGalleryStore(imagesArray, availableTags);
      setCategoryStore(store);
    }
  }, [imagesArray]);
  return <>
      <div id={code} sx={styles.headerContainer(background || defaultBackground, marginTop, marginBottom)}>
        <div sx={styles.headerWrapper} data-testid="category-gallery-block-header-wrapper">
          <ListingHeader isFirst={isFirst} allImagesCount={allImagesCount} title={title} description={description} haveFilters={shouldRenderFilters} />
          {shouldRenderFilters && <>
              <Filters categoryStore={categoryStore} />
              <ActiveFiltersChips categoryStore={categoryStore} />
            </>}
          {isWiderThanTablet ? <Listing images={images} /> : <ListingMobile images={images} />}
        </div>
        <ListingFooter categoryStore={categoryStore} />
      </div>

      <DynamicAside active={isAsideOpen} onCloseAside={() => closeAside()}>
        <CategoryAsideFilters categoryStore={categoryStore} />
      </DynamicAside>
    </>;
};
export default observer(CategoryGalleryBlock);